import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const getPickRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/picks/:id',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/picks/:id' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getPickResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 129,
        'number': 'S10074',
        'status': 'Finished',
        'type': 'Pick',
        'priority': '3-Normal',
        'locationGroup': {
            'id': 5,
            'name': 'SLC'
        },
        'username': 'admin',
        'dateCreated': '2026-04-03T04:19:58.933+00:00',
        'dateScheduled': '2026-01-07T13:54:21.000+00:00',
        'dateStarted': '2026-04-03T04:37:56.242+00:00',
        'dateFinished': '2026-04-03T04:37:56.242+00:00',
        'dateLastModified': '2026-04-03T04:37:56.445+00:00',
        'toBePrinted': false,
        'pickItems': [
            {
                'id': 548,
                'part': {
                    'id': 44,
                    'name': 'iTrack',
                    'description': 'Tracking Edge 705'
                },
                'status': 'Finished',
                'type': 'Normal',
                'quantity': '1',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 1,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 157
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'tracking': {
                    'trackingItems': [
                        {
                            'partTracking': {
                                'id': 4,
                                'name': 'Serial Number',
                                'description': ''
                            },
                            'serialNumbers': [
                                {
                                    'numbers': [
                                        {
                                            'partTracking': {
                                                'id': 4,
                                                'name': 'Serial Number',
                                                'description': ''
                                            },
                                            'value': 'ITRACK-35B675'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            {
                'id': 547,
                'part': {
                    'id': 79,
                    'name': 'B203',
                    'description': 'Basic Brake Cables'
                },
                'status': 'Finished',
                'type': 'Normal',
                'quantity': '8',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 1,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 156
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'currentTag': {
                    'id': 3016,
                    'number': 550,
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'sourceTag': {
                    'id': 3016,
                    'number': 550,
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            },
            {
                'id': 549,
                'part': {
                    'id': 12,
                    'name': 'AC-01',
                    'description': 'Aluminum Casing'
                },
                'status': 'Entered',
                'type': 'Normal',
                'quantity': '4',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 2,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 158
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'sourceLocation': {
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            }
        ],
        'customFields': []
    },
};

const getPickAttributes: Attribute[] = [];

const data: RequestDefinitionData = {
    id: 'get-pick',
    title: 'Get a pick',
    description: 'Retrieves the details of an existing pick by ID. Requires PICK_VIEW access right. Validates location group access — returns 403 if the user does not have access to the pick\'s location group. Returns 404 if the pick is not found.',
    endpoint: {
        verb: 'GET',
        path: '/picks/:id',
        tooltip: 'Get a pick',
    },
    attributes: getPickAttributes,
    requestObject: getPickRequest,
    responseObject: getPickResponse,
};

export default data;
